import DeleteContactButton from 'components/Contact/DeleteContactButton';
import ResourceInformation from 'components/DetailsPage/ResourceInformation';
import TagsInformation from 'components/DetailsPage/TagsInformation';
import { Civility } from 'core/enums/civility';
import Contact from 'core/models/contact';
import { getParentOfContact, getRankOfContact } from 'core/useCases/contacts/utils';
import { ModalType } from 'core/useCases/modal/types';
import { useModalStore } from 'stores/modal';
import Edit from 'images/icons/Edit.svg?react';
import Informations from 'images/icons/Informations.svg?react';
import Mail from 'images/icons/Mail.svg?react';
import Mobile from 'images/icons/Mobile.svg?react';
import Phone from 'images/icons/Phone.svg?react';
import PlusOne from 'images/icons/PlusOne.svg?react';
import Talk from 'images/icons/Talk.svg?react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { SMultilineText } from 'styles/components';
import ContactStatus from '../../ContactStatus';
import MainInformation from './MainInformation';
import {
    SButtons,
    SContactStatusWrapper,
    SFemale,
    SImageWrapper,
    SInfo,
    SMale,
    SSecondaryInformation,
    SSubCards,
    SWrapper,
} from './styles';

type InformationProps = {
    contact: Contact;
};

const Information: FC<InformationProps> = ({ contact }) => {
    const history = useHistory();
    const openModal = useModalStore((s) => s.openModal);
    const { t } = useTranslation();
    const {
        email,
        phoneNumber,
        mobileNumber,
        status,
        civility,
        parent,
        comments,
        politesse,
        resources: persistedResources,
        tags,
    } = contact;
    const parentLabel = getParentOfContact(contact, t);
    const resources = persistedResources ? JSON.parse(persistedResources) : [];

    const openContactModal = () => {
        openModal({
            defaultValues: contact,
            title: t('contact-details.update-contact'),
            type: ModalType.Contact,
        });
    };

    return (
        <SWrapper>
            <SButtons>
                <button onClick={openContactModal} title={t('contact-details.update-contact')} type="button">
                    <Edit />
                </button>
                <DeleteContactButton contact={contact} postAction={() => history.push('/contacts')} />
            </SButtons>
            {Civility.Male === civility ? <SMale /> : <SFemale />}
            <SSubCards>
                <MainInformation contact={contact} />
                <SContactStatusWrapper>
                    <ContactStatus status={status} />
                </SContactStatusWrapper>
                <SSecondaryInformation>
                    {email && (
                        <SInfo>
                            <SImageWrapper>
                                <Mail />
                            </SImageWrapper>
                            <span>{email}</span>
                        </SInfo>
                    )}
                    {mobileNumber && (
                        <SInfo>
                            <SImageWrapper>
                                <Mobile />
                            </SImageWrapper>
                            <span>{mobileNumber}</span>
                        </SInfo>
                    )}
                    {phoneNumber && (
                        <SInfo>
                            <SImageWrapper>
                                <Phone />
                            </SImageWrapper>
                            <span>{phoneNumber}</span>
                        </SInfo>
                    )}
                    {politesse && (
                        <SInfo>
                            <SImageWrapper>
                                <Talk />
                            </SImageWrapper>
                            <span>{t(`common.politesse.enum.${politesse}`)}</span>
                        </SInfo>
                    )}
                    <SInfo>
                        <SImageWrapper>
                            <PlusOne />
                        </SImageWrapper>
                        <span>{`${getRankOfContact(contact)}, `}</span>
                        {parent ? (
                            <Link to={`/contact/${parent.id}`}>
                                <span>{parentLabel}</span>
                            </Link>
                        ) : (
                            <span>{parentLabel}</span>
                        )}
                    </SInfo>
                    {comments && (
                        <SInfo>
                            <SImageWrapper>
                                <Informations />
                            </SImageWrapper>
                            <SMultilineText>{comments}</SMultilineText>
                        </SInfo>
                    )}
                </SSecondaryInformation>
                <ResourceInformation resources={resources} />
                <TagsInformation tags={tags} />
            </SSubCards>
        </SWrapper>
    );
};

export default Information;
